module.exports = __webpack_public_path__ + "img/2021-08-23.f262cdc9.jpg";